import { create } from "zustand";
import { combine, createJSONStorage } from "zustand/middleware";

export const adminStore = create(
  combine(
    {
      userProfile: null,
      profileLoaded: false,
    },
    (set) => ({
      setUserProfile: (userProfile) =>
        set({ userProfile, profileLoaded: true }),
      clearProfileLoaded: () => set({ profileLoaded: false }),
      setOnboardingData: (data) =>
        set((state) => ({
          userProfile: { ...state.userProfile, ...data },
        })),
    }),
  ),
  { name: "park-pay-admin", storage: createJSONStorage(() => sessionStorage) },
);
